module.exports = __webpack_public_path__ + "img/rule02.8ac00b5a.png";